<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { ASSUME_ROLE_ENABLED } from "@/helpers/config";
import { RoleDetails } from "@/constants/Roles";

const authStore = useAuthStore();
const isEnabled = ASSUME_ROLE_ENABLED;

const { assumedRole, issuedRoles, isAssumingRole } = storeToRefs(authStore);
const { assumeRole, resetRoles } = authStore;
</script>

<template>
  <div v-if="isEnabled">
    <v-chip v-if="isAssumingRole" class="mx-2" variant="flat">
      {{ assumedRole }}
    </v-chip>
    <v-menu offset-y open-on-hover>
      <template #activator="{ props }">
        <v-btn class="ml-2" v-bind="props" dark left icon="account_circle" />
      </template>
      <v-list>
        <v-list-item
          v-for="issuedRole in issuedRoles"
          :key="issuedRole"
          @click="assumeRole(issuedRole)"
        >
          <v-list-item-title>{{ RoleDetails[issuedRole].displayName }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="resetRoles">
          <v-list-item-title>Reset Roles</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped lang="scss">
.assume-role-list-width {
  min-width: 100px;
}
</style>
